export default __webpack_public_path__ + "static/media/bg-workspace.1ae577b1.png";